import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import BlacklistCountries from "./BlacklistCountries";
import Countries from "./Countries";

const CountryIndex = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="card" style={{background: "transparent", padding: "0px 10%"}}>
      <TabView
        className=""
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="List Countries ">
          <Countries />
        </TabPanel>
        <TabPanel header="Blacklisted Countries">
          <BlacklistCountries />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default CountryIndex;
